import { gql } from 'apollo-angular';

export const OfficeInfoFragment = gql`
  fragment OfficeInfoFragment on OfficeInfo {
    id
    name
    permalink
    phone
    emailAccount
    distance
    address1
    address2
    city
    state
    zip
    latitude
    longitude
  }
`;

export const ProviderInfoFragment = gql`
  fragment ProviderInfoFragment on ProviderInfo {
    id
    displayName
    image
    isPcp
    isPcpTeam
    isCrossCredentialed
  }
`;

export const AppointmentInventoryInfoFragment = gql`
  fragment AppointmentInventoryInfoFragment on AppointmentInventoryInfo {
    id
    startTime
    date
    duration
    utcStartDatetime
    timezoneName
    timezoneTzinfo
    bookableRemoteMsas
    bookableInPersonMsas
    appointmentInventoryBookingRules
  }
`;

export const ProviderOfficeResultFragment = gql`
  fragment ProviderOfficeResultFragment on ProviderOfficeResult {
    office {
      ...OfficeInfoFragment
    }
    provider {
      ...ProviderInfoFragment
    }
    appointmentInventoriesByDate {
      date
      inventories {
        ...AppointmentInventoryInfoFragment
      }
    }
    nextInventory {
      ...AppointmentInventoryInfoFragment
    }
  }
  ${OfficeInfoFragment}
  ${ProviderInfoFragment}
  ${AppointmentInventoryInfoFragment}
`;
